import { render, staticRenderFns } from "./Policydetails.vue?vue&type=template&id=5d0efe75&scoped=true&"
import script from "./Policydetails.vue?vue&type=script&lang=js&"
export * from "./Policydetails.vue?vue&type=script&lang=js&"
import style0 from "./Policydetails.vue?vue&type=style&index=0&id=5d0efe75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0efe75",
  null
  
)

export default component.exports